import React from "react";
import { Pagination, Table } from "components";
import { PaginatedTableProps } from "./PaginatedTable.props";

const PaginatedTable = React.memo<PaginatedTableProps>(
    ({
        columns,
        data,
         totalCount = 0, // Assuming totalCount defaults to 0 if undefined
         pageSize = 10, // Assuming pageSize defaults to 10 if undefined
         currentPage = 1, // Assuming currentPage defaults to 1 if undefined
        params,
        withDnd = false,
        onPageChange = () => {},
        refetch,
        onRowClick,
        onRightClick,
        rightCellNumber,
        className = "",
        withoutPagination = false,
        newTabLink,
        withRightClick = false,
        ...props
    }) => {
        if ( !withoutPagination ) {
            return (
                <>
                    <Table
                        columns={columns}
                        data={data}
                        onRowClick={onRowClick}
                        className={className}
                        withDnd={withDnd}
                        params={params}
                        refetch={refetch}
                        newTabLink={newTabLink}
                        onRightClick={onRightClick}
                        withRightClick={withRightClick}
                        {...props}
                    />
                    <Pagination
                        totalCount={totalCount}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        onPageChange={onPageChange}
                    />
                </>
            );
        }

        return (
            <Table
                columns={columns}
                data={data}
                onRowClick={onRowClick}
                className={className}
                withDnd={withDnd}
                params={params}
                refetch={refetch}
                newTabLink={newTabLink}
                onRightClick={onRightClick}
                withRightClick={withRightClick}
                {...props}
            />
        )
    }
);

export default PaginatedTable;
